import * as React from 'react';
import { composer } from '../../component-decorators/composer';
import { config } from '../../config';
import { HomeSEO } from './homeSEO';
import { WithFetcher } from '../../component-decorators/with-fetcher';
import { httpClient } from '../../http-client';
import { EditorType, Origin } from '../..';
import { mapOriginToQueryParam } from '../../common/utils';
import { CenteredLoader } from '../centered-loader';
import { useConfigContext } from '../../config-context';
import { HomeComponentWrapper } from './homeComponent';
var getHomeLayout = function (route, locale, experiments, rpcClient) {
    var baseURl = 'marketplace-api/v1';
    var platformBTest = (experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.platform-b')) &&
        !(config.editorType === EditorType.ADI);
    var platform = mapOriginToQueryParam(route);
    var platformParamName = platformBTest ? platform + "-b" : platform;
    var isSSR = typeof window === 'undefined';
    if (isSSR && rpcClient !== undefined) {
        return rpcClient.getContainer({
            platformName: platformParamName,
            containerName: 'home',
            withWebSolutions: true,
            lang: locale,
        });
    }
    return httpClient
        .get(config.baseApiUrl + "/_api/" + baseURl + "/container?platformName=" + platformParamName + "&containerName=home&withWebSolutions=true&lang=" + locale)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
var getHomeLayoutInReview = function (route, locale, experiments) {
    var baseURl = 'marketplace-api/v1';
    return httpClient
        .get(config.baseApiUrl + "/_api/" + baseURl + "/container?platformName=" + mapOriginToQueryParam(route) + "&containerName=home&withWebSolutions=true&inReview=true&lang=" + locale)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
var initialFetch = function (route, locale, experiments, rpcClient) {
    var useInReview = experiments && experiments.enabled('specs.marketplace.UseInReview');
    return function () {
        return Promise.all([
            useInReview
                ? getHomeLayoutInReview(route, locale, experiments)
                : getHomeLayout(route, locale, experiments, rpcClient),
        ]);
    };
};
export var Home = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var experiments = _a.experiments, marketplaceStore = _a.marketplaceStore;
    // tslint:disable-next-line: react-hooks-nesting
    var _b = useConfigContext(), locale = _b.locale, getAppInstance = _b.getAppInstance, isMobile = _b.isMobile, rpcClient = _b.rpcClient;
    var signedInstance = getAppInstance
        ? getAppInstance('22bef345-3c5b-4c18-b782-74d4085112ff')
        : undefined;
    console.log("marketplace-component/src/components/home/home.tsx - line 66 - " + Date.now());
    return (React.createElement(WithFetcher, { initialFetch: initialFetch(marketplaceStore.route, locale, experiments, rpcClient), fetchMemoizationId: "home-" + locale, loader: React.createElement(CenteredLoader, null) }, function (_a) {
        var fetchData = _a.fetchData;
        return (React.createElement("span", null,
            config.origin === Origin.STANDALONE.toString() && (React.createElement(HomeSEO, { data: fetchData[0], url: config.baseApiUrl })),
            React.createElement(HomeComponentWrapper, { fetchData: fetchData, locale: locale, signedInstance: signedInstance, isMobile: isMobile })));
    }));
});
//# sourceMappingURL=home.js.map